import {
  UPDATE_VALID_FORM_DATA,
  UPDATE_FROM_GETDATA,
  ADD_BENEFIT_ITEM,
  UPDATE_CLAIMDATA_PROPERTY,
} from "../actions"

// Develop note
// Now the initial state is left in pristine conditions and the resulting state is just a copy of the initial state. Remember two key points for avoiding mutations in Redux:
// --use concat(), slice(), or the spread operator for arrays
// --use Object.assign() or object spread of objects

const initialClaimData = {
  claimAttributeModel: {
    UpStatus: "",
    ContractClass: "",
    ContractType: "",
    PurchaseDt: "",
  },
  claimLifeDetailModel: {
    // Firsr page Deceased data
    deceasedName: "",
    NRIC: "",
    DOB: "",

    policyHolderName: "",
    policyNumber: "",
    claimantName: "",
    claimantNricNumber: "",
    claimantEmail: "",
    claimantMobile: "",
    representativeName: "",
    representativeCode: "",
    representativeBranch: "",
    representativeContactNo: "",
    deathNature: "",
    deathOccur: "",
    //claimantDOB: "1995-01-11T00:00:00",
    claimantDOB: "",
    claimantPostalCode: "",
    claimantAddress: "",
    claimantUnitNo: "",
    relationshipWithDeceased: "",
    beneficiaryWill: false,
    nonUSPerson: true,
    nonUSPersonWithAddress: false,
    USPerson: false,
    deathDate: "",
    deathTime: "",
    locationReason: "",
    accidentDesc: "",
    reportToPolice: false,
    reportInNewspaper: false,
    postMortem: false,
    deathCause: "",
    deathLocation: "",
    accidentLocation: "",
    firstComplaintDate: "",
    firstConsultationDate: "",
    regularDoctorName: "",
    regularDoctorAddress: "",
    regularDoctorContactNo: "",
    otherPolicyInforced: true,
    productType: "",

    // policyHolderName: "Policyholder Name",
    // policyNumber: "AB123456",
    // claimantName: "Claimant Name",
    // claimantNricNumber: "S0000000J",
    // claimantEmail: "shongwei.c@devops.etiqa.com.sg",
    // claimantMobile: "98063015",
    // representativeName: "R Name",
    // representativeCode: "5566",
    // representativeBranch: "Bukit Batok",
    // representativeContactNo: "98063015",
    // deathNature: "death nature",
    // deathOccur: "Singapore",
    // //claimantDOB: "1995-01-11T00:00:00",
    // claimantDOB: "01/02/1992",
    // claimantPostalCode: "048582",
    // claimantAddress: "address",
    // claimantUnitNo: "02-45",
    // relationshipWithDeceased: "Spouse",
    // beneficiaryWill: false,
    // nonUSPerson: false,
    // nonUSPersonWithAddress: false,
    // USPerson: true,
    // // deathDate: "2020-01-01T15:00:00",
    // deathDate: "01/01/2020",
    // deathTime: "22:15",
    // deathCause: "death cause",
    // deathLocation: "death location",
    // accidentLocation: "accident location",
    // firstComplaintDate: "02/09/2020",
    // firstConsultationDate: "02/09/2020",
    // doctorName: "doctor name",
    // doctorAddress: "doctor addr",
    // regularDoctorNameAddress: "name, address",
    // otherPolicyInforced: true,
    // productType: "",

    declaration: false,
    sourceSystem: "Web",
    planPeriodFrom: "",
    planPeriodTo: "",
  },
  claimLifeDeceasedModel: {
    deceasedName: "",
    NRIC: "",
    DOB: "",
    maritalStatus: "",
    postalCode: "",
    address: "",
    unitNo: "",
    familyLeft: "",
    familyLeftArray: "",
    // deceasedName: "Deceaed name",
    // NRIC: "S0000001J",
    // DOB: "01/01/1992",
    // maritalStatus: "Single",
    // postalCode: "048582",
    // address: "no66",
    // unitNo: "06-66",
    // familyLeft: "Spouse",
  },
  claimLifeEmployerModel: {
    isDeceasedEmployed: false,
    employerName: "",
    postalCode: "",
    address: "",
    unitNo: "",
    officeTelNo: "",
    employmentDate: "",

    // employerName: "Employer name",
    // postalCode: "048582",
    // address: "no 88",
    // unitNo: "12-12",
    // officeTelNo: "98063015",
    // employmentDate: "01/01/1992",
    isDeathWorkRelated: false,
  },
  claimPayoutModel: {
    payoutType: "Direct Credit",
    bankBIC: "",
    bankName: "",
    otherBankName: "",
    accountNumber: "",
    accountName: "",

    // payoutType: "Direct Credit",
    // bankBIC: "123",
    // bankName: "OCBC",
    // accountNumber: "1234567890",
    // accountName: "ABC",
  },
  claimLifePhysicianListModel: [
    // {
    //   consultationDate: "2020-01-01T00:00:00",
    //   admissionDate: "2020-02-02T00:00:00",
    //   dischargeDate: "2020-03-03T00:00:00",
    //   diagnosis: "Diagnosis",
    //   doctorName: "Doctor Name",
    //   hospitalAddress: "no 69",
    // },
  ],
  claimLifeOtherPolicyListModel: [
    // {
    //   companyName: "Company Name",
    //   commencementDate: "01/12/2020",
    //   coverageType: "Type",
    //   sumAssured: 12000,
    // },
  ],
  claimUploadListModel: [],
  folderName: "",
  sessionId: null,
}

const claimDataReducer = (state = initialClaimData, action) => {
  const newState = Object.assign({}, state)
  let targetModal = action.targetModal

  switch (action.type) {
    case UPDATE_VALID_FORM_DATA:
      return {
        ...state,
        [targetModal]: {
          ...state[targetModal],
          ...action.newData,
        },
      }

    case UPDATE_FROM_GETDATA:
      let claimDetailProperty = "claimLifeDetailModel"
      return {
        ...state,
        [claimDetailProperty]: {
          ...state[claimDetailProperty],
          [targetModal]: action.newData,
        },
      }

    case UPDATE_CLAIMDATA_PROPERTY:
      return {
        ...state,
        [action.claimDetailProperty]: {
          ...state[action.claimDetailProperty],
          [targetModal]: action.newData,
        },
      }

    case ADD_BENEFIT_ITEM:
      return {
        ...state,
        [targetModal]: action.newItemList,
      }
    default:
      return newState
  }
}

export default claimDataReducer
